(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrapper = document.querySelector('.video-home-background');
    if (!wrapper) return;

    var desktopVideo = wrapper.querySelector('.video-home-background__video--desktop');
    var mobileVideo = wrapper.querySelector('.video-home-background__video--mobile');
    if (!desktopVideo || !mobileVideo) return;

    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function syncActiveVideo() {
      var active = mobileQuery.matches ? mobileVideo : desktopVideo;
      var inactive = mobileQuery.matches ? desktopVideo : mobileVideo;

      inactive.pause();

      if (active.paused) {
        active.play().catch(function () {});
      }
    }

    syncActiveVideo();
    mobileQuery.addEventListener('change', syncActiveVideo);
  })();

  } catch(e) { console.error(e); }
})();
})();
